import { gql } from '@apollo/client';

export * from './editUser.mutation.generated';

export const EDIT_USER = gql`
  mutation editUser($userInput: EditUserInput!, $userId: ID!) {
    editUser(input: { userInput: $userInput, userId: $userId }) {
      success
      errors
      user {
        id
        name
        email
        phone
        role
      }
    }
  }
`;
